import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
import { onIonViewDidEnter, onIonViewWillLeave } from '@ionic/vue';

/**
 * Android 16 (API 36) enforces edge-to-edge, so the system bars draw on top of
 * whatever header the current view renders. The style names describe the
 * background, not the content: Dark = light clock and icons, Light = dark ones.
 *
 * Most views use the dark teal UniversalHeader, so that is the app default.
 */
export const DEFAULT_SYSTEM_BAR_STYLE = SystemBarsStyle.Dark;

export const setSystemBarStyle = async(style: SystemBarsStyle) => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  // Never let a failed styling call break the calling view.
  try {
    await SystemBars.setStyle({ style });
  } catch (e) {
    console.error('Could not set system bar style', e);
  }
};

/**
 * For views with a light header, where the default light clock and icons would
 * be unreadable. Restores the app default when leaving the view.
 */
export const useLightSystemBars = () => {
  onIonViewDidEnter(() => setSystemBarStyle(SystemBarsStyle.Light));
  onIonViewWillLeave(() => setSystemBarStyle(DEFAULT_SYSTEM_BAR_STYLE));
};
